export const commonConstants = {
  RESET: 'RESET'
};